<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'options', 'colors', 'labels'],
  data () {
    return {
      defaultOptions: {
        legend: {
          display: false
        },
        cutoutPercentage: 30,
        tooltips: {
          enabled: false
        }
      },
      defaultData: {
        labels: '',
        datasets: [
          {
            label: '',
            borderWidth: 0,
            backgroundColor: [],
            data: [0, 100]
          }
        ]
      }
    }
  },
  mounted () {
    if (this.data) this.defaultData.datasets[0].data = this.data
    this.defaultData.labels = this.labels

    this.defaultData.datasets[0].backgroundColor = this.colors

    this.addPlugin({
      afterDatasetsDraw: function (chart, easing) {
        var ctx = chart.ctx

        chart.data.datasets.forEach(function (dataset, i) {
          var dataSum = 0
          dataset.data.forEach(function (element) {
            dataSum += element
          })

          var meta = chart.getDatasetMeta(i)
          if (!meta.hidden) {
            meta.data.forEach(function (element, index) {
              // Draw the text in black, with the specified font
              ctx.fillStyle = 'rgb(255, 255, 255)'

              var fontSize = 10
              var fontStyle = 'bold'
              var fontFamily = 'Helvetica Neue'
              // eslint-disable-next-line
              ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

              // Just naively convert to string for now
              var labelString = chart.data.labels[index].substring(0, 5) + '...'
              var dataString = (Math.round(dataset.data[index] / dataSum * 1000) / 10).toString() + '%'

              // Make sure alignment settings are correct
              ctx.textAlign = 'center'
              ctx.textBaseline = 'middle'

              var padding = 5
              var position = element.tooltipPosition()
              ctx.fillText(labelString, position.x, position.y - (fontSize / 2) - padding)
              ctx.fillText(dataString, position.x, position.y + (fontSize / 2) - padding)
            })
          }
        })
      }
    })
    this.renderChart(this.defaultData, this.options || this.defaultOptions)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/share/DoughnutChartQuestion.vue